var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donor-temporary-page donor-wrapper"},[_c('download-popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }